// Запрос установки PWA. SPEC pwa-shell §4.7 (FR-PWA-01) / §4.8 (iOS).
//
// Перехватываем браузерный `beforeinstallprompt`, чтобы показать СВОЮ кнопку «Установить» в
// подходящий момент (а не сразу). `canInstall`/`promptInstall()` экспонируются в окно. iOS не шлёт
// beforeinstallprompt → там canInstall=false, app-ui показывает инструкцию «Поделиться → На экран
// Домой». Контроллер инъецируем (без прямого доступа к window) — тестируется в Node.
/**
 * Контроллер установки. Накапливает отложенный prompt, отдаёт `canInstall`, проигрывает выбор
 * пользователя, сбрасывается после установки. Не держит ссылок на window — только инъекция событий.
 */
export class InstallController {
    deferred = null;
    installed = false;
    /** Вызывается из window-слушателя beforeinstallprompt: гасим браузерный промпт, копим событие. */
    onBeforeInstallPrompt(event) {
        event.preventDefault();
        this.deferred = event;
    }
    /** Вызывается из window-слушателя appinstalled: прячем кнопку (§4.7). */
    onAppInstalled() {
        this.installed = true;
        this.deferred = null;
    }
    /** Можно ли показать свою кнопку «Установить» (есть отложенный промпт и ещё не установлено). */
    get canInstall() {
        return !this.installed && this.deferred !== null;
    }
    get isInstalled() {
        return this.installed;
    }
    /**
     * Проигрывает отложенный промпт (по клику пользователя). Возвращает исход. После любого исхода
     * браузер инвалидирует событие — сбрасываем deferred (повторно показать нельзя без нового события).
     * Нет отложенного промпта (iOS/уже установлено) → 'unavailable'.
     */
    async promptInstall() {
        const event = this.deferred;
        if (event === null)
            return 'unavailable';
        this.deferred = null;
        await event.prompt();
        const choice = await event.userChoice;
        return choice.outcome;
    }
}
/**
 * Детект standalone-режима (§4.8). Чистая функция над инъецированными «зондами» (в окне передают
 * window.matchMedia + navigator.standalone). standalone ⇔ запущено как установленное PWA.
 */
export function detectStandalone(probes) {
    return probes.displayModeStandalone || probes.navigatorStandalone === true;
}
/**
 * Детект iOS/iPadOS по платформенным зондам (НЕ парс user-agent ради фичи — §4.8 требует
 * feature-detection для возможностей; iOS-флаг нужен лишь для standalone-гейта пушей).
 * Принимает уже вычисленные платформенные признаки, чтобы оставаться чистой и тестируемой.
 */
export function isApplePlatform(probes) {
    if (probes.hasMSStream)
        return false; // старый IE/Edge mobile — не iOS
    if (/^(iPhone|iPad|iPod)/i.test(probes.platform))
        return true;
    // iPadOS 13+ маскируется под MacIntel с тач-экраном.
    return probes.platform === 'MacIntel' && probes.maxTouchPoints > 1;
}
//# sourceMappingURL=install.js.map